import { useState } from "react";
import { getAllPackages, clonePackage } from "../api/adminPackageClient";
import { AdminPackageDto } from "../api/models/PackageDto";

export const useAdminPackages = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [packages, setPackages] = useState<AdminPackageDto[]>([]);

    const fetchData = async () => {
        setIsLoading(true);
        try {
            setPackages(await getAllPackages());
        } finally {
            setIsLoading(false);
        }
    };

    const handleClonePackage = async (packageId: string): Promise<string> => {
        setIsLoading(true);
        try {
            const newPackageId = await clonePackage(packageId);
            await fetchData(); // Refresh the list
            return newPackageId;
        } finally {
            setIsLoading(false);
        }
    };

    return {
        fetchData,
        isLoading,
        setIsLoading,
        packages,
        handleClonePackage
    };
};